import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components';
import Icon from '../../../commons/Icon';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CatalogHeader = styled.div`
  flex-grow: 1;
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.screens.sm} {
    justify-content: flex-end;
    flex-direction: column;
    margin-bottom: 0;
    gap: 0;
  }
`

export const CompanyNameWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  @media ${({ theme }) => theme.screens.sm} {
    padding-top: 2rem;
  }
`;

export const CompanyNameLink = styled(Link)`
  background-color: ${({theme}) => theme.colors.mono.greyLight};
  padding: 1rem;
  width: 100%;
  border-radius: 8px;
`;

export const CompanyName = styled.h2`
  text-decoration: none;
  text-align: center;
  color: ${({theme}) => theme.colors.primary.default}
`;

export const CatalogSearchBarWrapper = styled.div`
  max-width: 80rem;
  width: 100%;
  position: relative;
  margin: 2rem 0;
  order: 1;
  @media ${({ theme }) => theme.screens.sm} {
    align-self: end;
    order: 2;
  }
`

export const CatalogSearchBar = styled.input`
  width: 100%;
  padding: 1.3rem;
  padding-left: 5rem;
  border: 2px solid #e3e6e8;
  border-radius: 6px;
  margin-right: 4rem;
`

export const CatalogSearchBarIcon = styled(Icon)`
  position: absolute;
  left: 1.5rem;
  top: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;
  stroke: ${({ theme }) => theme.colors.primary.default};
`

// Swiper de categorias
export const CategoriesMenuWrapper = styled.div`
  margin-bottom: 2rem;
`

export const CatalogCategoriesSwiper = styled(Swiper)``;

export const CatalogSlide = styled(SwiperSlide)`
  width: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Category = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 30%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({theme}) => theme.colors.primary.dark};
  background-color: ${({theme}) => theme.colors.primary.light};
  transition: transform 0.2s;
`;

export const CategoryLink = styled(Link)`
  display: flex;
  flex-direction: column;
`;

export const CategoryIcon = styled(FontAwesomeIcon)`
  width: 2rem;
  height: 2rem;
`;

export const CategoryImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  min-width: fit-content;
  min-height: fit-content;
`;

export const CategoryLabel = styled.span`
  margin-top: 8px;
  font-size: ${({ theme }) => theme.fontSize.md};
  text-align: center;
  max-width: 68px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({theme}) => theme.colors.primary.dark};
  font-weight: bold;
`;
